import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { T } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const { user } = useAuth() || {};
  const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
  const [lang, setLang] = useState(user?.language || stored || "en");

  useEffect(() => {
    if (user?.language && user.language !== lang) setLang(user.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("lang", lang);
  }, [lang]);

  const t = useMemo(() => (k) => (T[lang] && T[lang][k]) || T.en[k] || k, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
